import { Constants } from '@constants';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

export const isSelectedAmountValid = (
    selectedAmount: number,
    selectedOffer: TFormalOffer | null
) => {
    if (!selectedOffer) return false;

    // Cashless offers have an available_cash of 0, so the selected amount is always valid
    if (selectedOffer.is_repayment_reduction) return true;

    const maxAvailableCash = selectedOffer.available_cash!;

    return (
        !selectedAmountGreaterThanMaxAvailableCash(
            selectedAmount,
            maxAvailableCash
        ) && !selectedAmountLessThanMinDrawDown(selectedAmount)
    );
};

export const selectedAmountGreaterThanMaxAvailableCash = (
    selectedAmount: number,
    maxAvailableCash: number
) => {
    return selectedAmount > maxAvailableCash;
};

export const selectedAmountLessThanMinDrawDown = (selectedAmount: number) => {
    return selectedAmount < Constants.MIN_DRAW_DOWN_AMOUNT;
};
